import { toDateInput } from 'helpers/date';

/**
 * Turns the report the API answered with into the shape the form works on.
 *
 * The Young Crew edits this shape and the YC Management Board reads it, so both
 * screens build it the same way - the review screen would otherwise have to
 * guess at how the form reads a stored report back.
 */
const buildFormState = (data) => {
  if (!data) return null;

  return {
    yearlyPlan: data.yearlyPlan || [],
    yearlyPlanNew: [],
    yearlyBudget: data.yearlyBudget || [],
    yearlyBudgetNew: [],
    removedFiles: [],
    participatedInGlobalEvents:
      data.participatedInGlobalEvents === undefined ? null : data.participatedInGlobalEvents,
    globalEvents: data.globalEvents || [],
    events: (data.events || []).map((event) => {
      return {
        key: event.key,
        id: event.id,
        // Only a card added by hand eases in; the ones a stored report came
        // with are already on screen.
        isNew: false,
        registered: !!event.registered,
        eventId: event.eventId,
        // What the stored event looked like when it was saved. The dropdowns
        // are built from what the Young Crew can pick today, which the review
        // screen does not get at all and which drops an event cancelled since,
        // so the card falls back on these to still name what was reported.
        storedEvent: event.registered
          ? {
              value: event.eventId,
              label: event.name,
              date: event.date,
              modeOfDelivery: event.modeOfDeliveryLabel,
            }
          : null,
        storedModeOfDelivery:
          !event.registered && event.modeOfDelivery
            ? { value: event.modeOfDelivery, label: event.modeOfDeliveryLabel }
            : null,
        name: event.registered ? null : event.name,
        date: event.registered ? null : toDateInput(event.date),
        modeOfDelivery: event.modeOfDelivery,
        participants: event.participants === null ? null : String(event.participants),
        proof: event.proof || [],
        newProof: [],
        removedProofFiles: [],
      };
    }),
  };
};

export default buildFormState;
